export const dataTableInfoMock = [
  ["Ana Silva", "C98456A", "ana@exemplo.com.br", "Usuário", "Ativa", "Ativado", ""],
  ["Ana Silva", "C98456A", "ana@exemplo.com.br", "Administrador de acessos", "Ativa", "Ativado", ""],
  [
    "Maria Souza",
    "C98456A",
    "maria@exemplo.com.br",
    "Responsável pelo contrato",
    "Ativa",
    "Ativado",
    "",
  ],
  [
    "Paulo Souza",
    "C98456A",
    "paulo.souza@empexemplo.com.br",
    "Usuário",
    "Bloqueada",
    "Desativado",
    "",
  ],
];
